module.exports = __webpack_public_path__ + "static/media/dharun-shankar.60ed7273.jpeg";